import * as React from 'react'

function TransactionsIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={21} height={19} viewBox="0 0 21 19" {...props}>
      <g data-name="Group 7764">
        <g data-name="Group 5811" transform="translate(-79 -353.243) translate(79 353.243)">
          <path data-name="Rectangle 2102" fill="#fff" d="M0 0H20V19H0z" />
          <path data-name="Rectangle 2102 - Outline" d="M1.6 1.6v15.8h16.8V1.6H1.6M0 0h20v19H0z" fill="CurrentColor" />
          <path
            data-name="Rectangle 6418"
            d="M4 0h6v8H4a4 4 0 01-4-4 4 4 0 014-4z"
            transform="translate(11 5.501)"
            fill="#fff"
          />
          <path
            data-name="Rectangle 6418 - Outline"
            d="M4 1.6a2.4 2.4 0 000 4.8h4.4V1.6H4M4 0h6v8H4a4 4 0 010-8z"
            transform="translate(11 5.501)"
            fill="CurrentColor"
          />
        </g>
        <path
          data-name="Path 17327"
          d="M12.131-7.567h-1.6v-1.6h1.6z"
          transform="translate(-79 -353.243) translate(83.1 371.11)"
          fill="CurrentColor"
        />
      </g>
    </svg>
  )
}

export default TransactionsIcon
